module.exports = __webpack_public_path__ + "static/media/actionDropdown.e55b99c0.png";